import { getDoc } from 'firebase/firestore/lite'
import refs from '../refsLite'

export async function getSection(sectionId) {
  const sectionSnap = await getDoc(refs.section(sectionId))
  return sectionSnap.data() || null
}
